import { eventQBus } from '@otto-ec/global-resources/event-q-bus'
import { Cookies } from './cookies'

export interface AppsBridge {
  runningInApp(): boolean
  appType(): 'android' | 'ios' | undefined | ''

  cmp: {
    openPreferenceCenter(): void
    optOutAll(): void
    optOutGeneralVendor(vendorId: string): void
  }
}

declare global {
  interface Window {
    o_apps: AppsBridge
  }
}

export enum APP_RESURFACE_BANNER_EVENTS {
  ResurfaceBanner = `apps.cookie-banner.resurface`,
}

export class AppsAdapter {
  constructor(private readonly cookies: Cookies) {}

  runningInApp(): boolean {
    return this.cookies.getAppCookieValue()
  }
  appType() {
    return this.apps?.appType()
  }

  openPreferenceCenter(): void {
    this.apps?.cmp.openPreferenceCenter()
  }

  resurfaceBanner(): void {
    return eventQBus.emit(APP_RESURFACE_BANNER_EVENTS.ResurfaceBanner)
  }

  optOutAll(): void {
    this.apps?.cmp.optOutAll()
  }
  optOutGeneralVendor(vendorId: string): void {
    this.apps?.cmp.optOutGeneralVendor(vendorId)
  }

  private get apps(): AppsBridge | undefined {
    return window.o_apps ?? undefined
  }
}
